const data = Object.freeze({
  Draft: 1,
  Submitted: 2,
  Validated: 3,
  Rejected: 4,
  Cancelled: 5,
});
export default data;
